import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

const THEME_REF = () => doc(db, "settings", "theme");
const SITE_REF = () => doc(db, "settings", "site");
const CACHE_KEY = "mu:settings:v1";

function withTimeout(promise, ms) {
  return Promise.race([
    promise,
    new Promise((_, reject) => setTimeout(() => reject(new Error("timeout")), ms)),
  ]);
}

export function readCachedSettings() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function writeCache(data) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

// Tema ve site ayarlarını Firestore'dan okur. Hata/timeout durumunda null döner (varsayılanlar kullanılır).
export async function loadSettings() {
  try {
    const [themeSnap, siteSnap] = await withTimeout(
      Promise.all([getDoc(THEME_REF()), getDoc(SITE_REF())]),
      4000
    );
    const data = {
      theme: themeSnap.exists() ? themeSnap.data() : null,
      site: siteSnap.exists() ? siteSnap.data() : null,
    };
    writeCache(data);
    return data;
  } catch (err) {
    if (process.env.NODE_ENV !== "production") console.warn("settings load failed", err.message);
    return null;
  }
}

export async function saveTheme(theme) {
  await setDoc(THEME_REF(), { ...theme, updatedAt: serverTimestamp() });
}

export async function saveSite(site) {
  await setDoc(SITE_REF(), { ...site, updatedAt: serverTimestamp() }, { merge: true });
}
